import React from 'react';
import styles from './CallControls.module.css';

interface CallControlsProps {
  isMuted: boolean;
  onToggleMute: () => void;
  onEndCall: () => void;
}

export const CallControls: React.FC<CallControlsProps> = ({
  isMuted,
  onToggleMute,
  onEndCall,
}) => {
  return (
    <div className={styles.controls}>
      <button
        className={`${styles.controlButton} ${isMuted ? styles.muted : ''}`}
        onClick={onToggleMute}
        aria-label={isMuted ? 'Unmute microphone' : 'Mute microphone'}
        aria-pressed={isMuted}
      >
        {isMuted ? '🔇' : '🎤'}
        <span className={styles.buttonLabel}>
          {isMuted ? 'Unmute' : 'Mute'}
        </span>
      </button>

      <button
        className={`${styles.controlButton} ${styles.endCall}`}
        onClick={onEndCall}
        aria-label="End call"
      >
        📞
        <span className={styles.buttonLabel}>End Call</span>
      </button>
    </div>
  );
};
